import { render, staticRenderFns } from "./PrintCertificatesModal.vue?vue&type=template&id=0ac6a91c"
import script from "./PrintCertificatesModal.vue?vue&type=script&lang=js"
export * from "./PrintCertificatesModal.vue?vue&type=script&lang=js"
import style0 from "./PrintCertificatesModal.vue?vue&type=style&index=0&id=0ac6a91c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports